<template lang="pug">
.container-fluid
  vm-row.login-row(vm-w="12")
    vm-col.login-col(vm-justify="center", vm-align="center", vm-lg=4, vm-sm=12)
      router-view

    vm-col.login-background(
      vm-align="center",
      vm-lg=8,
      vm-sm=0,
      vm-xs=0,
      vm-offset=4
    )
</template>

<script>
export default {
  name: 'BaseAuth'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.container-fluid {
  height: 100vh;
  padding-right: 0px !important;
  padding-left: 0px !important;
}
form {
  margin-left: auto;
  margin-right: auto;
  margin-top: 35px;
  max-width: 380px;
}
.login-background {
  height: 100vh;
  background: url('/background.png') no-repeat center / contain;
  background-color: #3494AC;
}
.login-col {
  -webkit-transition: all .3s;
  transition: all .3s;
  padding: 50px;
  position: fixed;
  overflow: auto;
  background-color: white;
  height: 100%;
  overflow: auto;
}
.login-screen,
.login-row {
  height: 100%;
}
.logo {
  margin-top: 0px;
}
.reset-password {
  padding-top: 0px;
}
.title {
  color: #000000;
  font-size: 17px;
  font-weight: 500;
  line-height: 1.1;
  margin-bottom: 20px;
}
.welcome {
  color: #ffffff;
  max-width: 555px;
  margin-bottom: 65px;
  margin-top: 65px;
  padding-right: 55px;
  h1 {
    font-size: 60px;
  }
  .sub-text {
    color: #ffffff;
  }
}
@media (min-width: 768px) {
  .login-screen {
    form {
      margin-top: 150px;
    }
  }
  .logo {
    margin-top: 50px;
  }
  .welcome {
    margin-bottom: 0px;
    margin-top: 285px;
  }
}
@media only screen and (max-width: 768px) {
  /* For mobile phones: */
  .container-fluid {
    height: 90vh;
  }
  .login-row {
    .login-col {
      -webkit-transition: all .3s;
      transition: all .3s;
       padding: 0px 35px;
      position: initial;
      bottom: 0;
      height: auto;
      border-radius: 40px 40px 0px 0px;
      form {
        margin-top: 45px !important;
      }
    }
    .login-background {
      display: none !important;
      height: 100%;
      padding-left: 0;
    }
  }
}
</style>
